





















import { Component, Vue } from 'vue-property-decorator'
import Axios from 'axios'

@Component({})
export default class VoucherField extends Vue {
  code: string = ''
  loading: boolean = false
  enabled: boolean = false
  errorMessage: string = ''
  applied: boolean = false
  message: string = ''
  discountPercentage: number = 0

  get disabled(): boolean {
    return !this.code
  }

  async checkCode() {
    if (this.disabled) return

    this.loading = true
    this.errorMessage = ''

    try {
      const { data } = await Axios.post('/voucher/check', {
        code: this.code
      })

      if (data.error) {
        this.errorMessage = data.errorMessage
      } else {
        this.applied = true
        this.discountPercentage = data.discountPercentage
        this.message = data.message

        this.$emit('update:discountPercentage', this.discountPercentage)
        this.$emit('update:voucherCode', this.code)
        this.$emit('update:freeSubscriptionDurationDays', data.freeSubscriptionDurationDays)
        this.$emit('update:voucherSubscriptionType', data.subscriptionType)
      }
    } catch (error) {
      console.error(error)

      if (error.request.status === 429) {
        this.errorMessage = 'Too many attempts.'
      } else {
        this.errorMessage = 'Something went wrong. Please try again.'
      }
    } finally {
      this.loading = false
    }
  }
}
